import { Styled } from '.';
import { useI18n } from 'contexts/i18n';
import { useContentful, useDoctorProfile } from 'reactQuery/queries';

export const Footer = () => {
  const i18n = useI18n();
  const { data: doctorProfile } = useDoctorProfile();
  const { data: contentfulData } = useContentful();
  // Extracting the properties from the content data or assigning empty objects if the content data is null or undefined
  const {
    privacyPolicy,
    termsOfUse,
    termsAndConditions,
    supportText,
    disclaimer,
  } = contentfulData?.globalContents || {};

  // Initializing variables to be populated with values based on the user's location and the content data
  let privacyPolicyLink = '';
  let termsOfUseLink = '';
  let termsAndConditionsLink = '';
  let supportTextContent = '';
  let disclaimerContent = '';
  const doctorCountry = doctorProfile?.country ?? 'US';
  const isCAFR =
  doctorProfile?.country === 'CA' &&
  doctorProfile?.locale === 'fr-CA';
  if (doctorProfile && typeof doctorProfile.region !== 'undefined') {
    privacyPolicyLink =
      privacyPolicy[doctorCountry] ?? privacyPolicy[doctorProfile.region];
    termsOfUseLink =
      termsOfUse[doctorCountry] ?? termsOfUse[doctorProfile.region];

    termsAndConditionsLink =
      termsAndConditions[doctorCountry] ??
      termsAndConditions[doctorProfile.region];
    
    if (isCAFR) {
      supportTextContent = i18n['For assistance please contact Customer Care at 888-822-5446.'];
    } else {
      supportTextContent =
        supportText[doctorProfile.country] ?? supportText['GB'];
      disclaimerContent = disclaimer[doctorProfile.country] ?? disclaimer['ENG'];
    }
  }

  return (
    <>
      <Styled.Container footer>
        <Styled.Disclaimer>{i18n['disclaimerContent']}</Styled.Disclaimer>
        <div
          dangerouslySetInnerHTML={{
            __html: supportTextContent,
          }}
        ></div>
        <Styled.SiteFooter>
          <div>© Align Technology, Inc. {i18n['All rights reserved.']}</div>
          <div>
            <Styled.Footerlink
              rel="noreferrer"
              target="_blank"
              href={privacyPolicyLink}
            >
              {i18n['Privacy']}
            </Styled.Footerlink>
            <Styled.Footerlink
              rel="noreferrer"
              target="_blank"
              href={termsOfUseLink}
            >
              {i18n['Terms of Use']}
            </Styled.Footerlink>
            {termsAndConditionsLink && termsAndConditionsLink.length > 0 && (
              <Styled.Footerlink
                rel="noreferrer"
                target="_blank"
                href={termsAndConditionsLink}
              >
                {i18n['Terms and Conditions']}
              </Styled.Footerlink>
            )}
          </div>
          <Styled.Footerlink id="teconsent"></Styled.Footerlink>
        </Styled.SiteFooter>
      </Styled.Container>
      <Styled.TeConsentBlackBar id="consent_blackbar"></Styled.TeConsentBlackBar>
    </>
  );
};

export default Footer;
